import { jsx as _jsx } from "react/jsx-runtime";
import { AppModalType } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { getAppsFlyerOrStoreLinks, getStoreLinkUrl } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/utils";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { trackEventOnClick } from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerMobileFooterDesktopappModalviewOnGooglePlayClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalViewOnGooglePlay";
import { trackRetailerMobileFooterDesktopappModalviewOnStoreClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalViewOnStore";
import React from "react";
export var ViewAppLink = function(props) {
    var trackEvent = function() {
        if (props.eventPrefix) {
            trackEventOnClick("".concat(props.eventPrefix, "/app-modal/view-on-store-click"));
        } else if (!isLoggedInRetailer()) {
            if (props.appModalType === AppModalType.APPSTORE) {
                trackRetailerMobileFooterDesktopappModalviewOnStoreClick();
            } else {
                trackRetailerMobileFooterDesktopappModalviewOnGooglePlayClick();
            }
        }
    };
    var getLinks = useViewport().isMobile ? getAppsFlyerOrStoreLinks : getStoreLinkUrl;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: props.appModalType === AppModalType.APPSTORE ? getLinks().app_store_link : getLinks().play_store_link,
        target: "_blank",
        onClick: function() {
            trackEvent();
        },
        children: props.appModalType === AppModalType.APPSTORE ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "9Q5CDz",
            defaultMessage: [
                {
                    type: 0,
                    value: "View on App Store"
                }
            ]
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "/tRj+F",
            defaultMessage: [
                {
                    type: 0,
                    value: "View on Google Play"
                }
            ]
        })
    });
};
